{
  "aboutFarmJoinCodes": "Acerca de los códigos de ingreso a la granja",
  "back": "Atrás",
  "codeExpired": "Código expirado",
  "codeExpiredErrorMessage": "El código de ingreso a su granja ha expirado. Para permitir que nuevos usuarios se unan a su cuenta de granja, debe crear un código nuevo.",
  "codeExpiresWithColon": "El código caduca:",
  "codeNotCreated": "Código no creado",
  "codeNotCreatedErrorMessage": "Debe crear un nuevo código de unión de granja para permitir que los usuarios se unan a su granja.",
  "codeWithColon": "Código:",
  "copyCode": "Copiar",
  "farmJoinCode": "Código de ingreso a la granja",
  "farmJoinCodeHelpSummary": "Los códigos de ingreso a la granja son códigos de 6 dígitos generados aleatoriamente que permiten que los nuevos usuarios se unan a una cuenta de granja. Cuando el usuario se une, comenzará con los permisos especificados para la granja.\n\nLos códigos de ingreso a la granja vencen después de un período de tiempo determinado. Si crea un código y este vence, deberá crear un código nuevo si desea que los nuevos usuarios puedan unirse a su granja.",
  "farmJoinCodeNotCreatedMessage": "Debe crear un nuevo código de unión de granja para permitir que los usuarios se unan a su granja.",
  "farmJoinCodeShareMessageWithActiveFarmNameAndCodeString": "Utilice este código de unión de granja para unirse a la granja {{activeFarmName}}\n{{codeString}}",
  "farmJoinCodeShareTitleWithActiveFarmName": "[FarmHQ]: Código de ingreso para {{activeFarmName}}",
  "farmJoinCodeStatus": {
    "ACTIVE": "Activo",
    "EXPIRED": "Venció",
    "NOT_CREATED": "No creado"
  },
  "farmJoinCodeTitle": "Código de ingreso a la granja",
  "newCode": "Nuevo código",
  "newFarmJoinCode": "Nuevo código para unirse a la granja",
  "newFarmJoinCodeHelpSummary": "Cuando un usuario se une a su granja ingresando un código de ingreso a la granja, se le asignan los permisos que se especificaron cuando se creó ese código. Un administrador de la granja puede cambiar los permisos de un usuario más adelante.",
  "note": "Nota: ",
  "shareCode": "Compartir",
  "somethingWentWrong": "Algo salió mal",
  "unableToCopyCode": "No se puede copiar el código",
  "yourCode": "Tu código"
}
